import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { EFileInfoFilterType } from '~/shared/types';
import { useService } from '~/services/service.base';
import { ServiceFileInfo } from '~/services/service.file.info';
import { ServiceUser } from '~/services/service.user';
import { ServiceCategoryTag } from '~/services/service.category.tag';
import { ServiceHistory } from '~/services/service.history';
import { AuthService } from '~/services/service.auth';
import { FileInfoVisitor } from '~/views/organisms/file-info-visitor';
import { FileInfoConnectedUser } from '~/views/organisms/file-info-connected-user';
import { t } from 'i18next';
export const useFileInfo = () => {
    const userService = useService(ServiceUser);
    const serviceCategoryTag = useService(ServiceCategoryTag);
    const historyService = useService(ServiceHistory);
    const authService = useService(AuthService);
    const fileInfoService = useService(ServiceFileInfo);
    fileInfoService.tabsService.use([
        {
            value: EFileInfoFilterType.details,
            label: t('DIALOG_FILE_INFO_DETAILS'),
        },
        {
            value: EFileInfoFilterType.tags,
            label: t('DIALOG_FILE_INFO_TAGS'),
        },
        {
            value: EFileInfoFilterType.fdd,
            label: t('DIALOG_FILE_INFO_FDD'),
        },
        {
            value: EFileInfoFilterType.relatedFiles,
            label: t('DIALOG_FILE_INFO_RELATED_FILES'),
        },
        {
            value: EFileInfoFilterType.history,
            label: t('DIALOG_FILE_INFO_HISTORY'),
        },
    ]);
    const closeFileInfoDialogHandler = useCallback(() => {
        fileInfoService.fileInfoOpenService.handleClose();
        fileInfoService.setItem(undefined);
    }, [fileInfoService]);
    const clickByFileInfoHandler = useCallback((item) => {
        fileInfoService.setItem(item);
        fileInfoService.fileInfoOpenService.handleOpen();
    }, [fileInfoService]);
    const clickByFileInfoConnectedHandler = useCallback((item) => {
        fileInfoService.setItem(item);
        fileInfoService.fileInfoOpenService.handleOpen();
        userService.getAdminUser(item.userId);
        serviceCategoryTag.getTags({ fileId: item.id });
        fileInfoService.getRelatedFiles(item.id);
        historyService.getHistory(item.id);
    }, [fileInfoService, historyService, serviceCategoryTag, userService]);
    const fileInfoContent = useMemo(() => {
        return !authService.isLogged ? (_jsx(FileInfoVisitor, { item: fileInfoService.item, closeButtonHandler: closeFileInfoDialogHandler, open: fileInfoService.fileInfoOpenService.open })) : (_jsx(FileInfoConnectedUser, { selectedTab: fileInfoService.tabsService.tab, open: fileInfoService.fileInfoOpenService.open, closeButtonHandler: closeFileInfoDialogHandler, item: fileInfoService.item, tabsService: fileInfoService.tabsService, tags: serviceCategoryTag.tags, relatedFiles: fileInfoService.relatedFiles, historyItems: historyService.history, userInfo: userService.adminUser }));
    }, [
        authService.isLogged,
        closeFileInfoDialogHandler,
        fileInfoService.fileInfoOpenService.open,
        fileInfoService.item,
        fileInfoService.relatedFiles,
        fileInfoService.tabsService,
        historyService.history,
        serviceCategoryTag.tags,
        userService.adminUser,
    ]);
    return {
        fileInfoHandler: authService.isLogged ? clickByFileInfoConnectedHandler : clickByFileInfoHandler,
        closeFileInfoDialogHandler,
        fileInfoContent,
    };
};
